import './_landing-three-card-module.scss';
import component from './landing-three-card-module';

export default component;
